import classNames from 'classnames';
import { FC, useEffect, useRef } from 'react';

import { MODAL_TYPES } from '@/widgets/modals/config/constants';
import type { ModalTypes } from '@/widgets/modals/config/types';
import { useModalStore } from '@/widgets/modals/model/store';

import styles from './isGuestTooltip.module.scss';

interface isGuestTooltip {
  className?: string;
  onClose: () => void;
  isActive: boolean;
}

const IsGuestTooltip: FC<isGuestTooltip> = (props) => {
  const { className, onClose, isActive } = props;
  const { openModal } = useModalStore();
  const tooltipRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (
        tooltipRef.current &&
        !tooltipRef.current.contains(event.target as Node) &&
        isActive
      ) {
        onClose();
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose, isActive]);

  function handleOpenModal(name: ModalTypes) {
    onClose();
    openModal(name);
  }

  return (
    <div
      ref={tooltipRef}
      className={classNames(styles.tooltip, className)}
      onClick={onClose}
    >
      <div className={styles.tooltip__wrapper}>
        <button
          className={classNames('button button--md-black')}
          onClick={() => handleOpenModal(MODAL_TYPES.signIn)}
        >
          Войти
        </button>
        <button
          className={classNames('button button--md-grey')}
          onClick={() => handleOpenModal(MODAL_TYPES.signUp)}
        >
          Зарегистрироваться
        </button>
      </div>
    </div>
  );
};

export default IsGuestTooltip;
